<script>
  import { DialogNew } from '@shopboxai/sb-portal-components';
  import { id } from '../../../utils';
  export let data = { name: '', id: id(), mobile: { items: [] }, desktop: { items: [] } };
</script>

<DialogNew {data} on:submit on:close>
  <div slot="header">Add name for the new grid</div>
  <div slot="content" class="dialog-form-wrapper">
    <input type="hidden" name="id" bind:value={data.id} />
    <label for="title">Grid Name</label>
    <input id="title" type="text" bind:value={data.name} />
  </div>
  <button slot="toggle" class="primary">Start From Scratch</button>
</DialogNew>

<style></style>
